import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import SupportPage from "./pages/SupportPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import HomePage from "./pages/HomePage";
import WameedhPrivacy from "./pages/WameedhPrivacy";
import WameedhSupport from "./pages/WameedhSupport";
import BarirPrivacy from "./pages/BarirPrivacy";
import BarirSupport from "./pages/BarirSupport";
import DallaPrivacy from "./pages/DallaPrivacy";
import DallaSupport from "./pages/DallaSupport";
import EulaPage from "./pages/EulaPage";

const router = createHashRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/eula",
    element: <EulaPage />,
  },
  {
    path: "/wameedh-privacy",
    element: <WameedhPrivacy />,
  },
  {
    path: "/wameedh-support",
    element: <WameedhSupport />,
  },
  {
    path: "/barir-privacy",
    element: <BarirPrivacy />,
  },
  {
    path: "/barir-support",
    element: <BarirSupport />,
  },
  {
    path: "/aldalla-privacy",
    element: <DallaPrivacy />,
  },
  {
    path: "/aldalla-support",
    element: <DallaSupport />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
